var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequiredActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill",
    clipPath: "url(#clip0_1779_3381)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M5.5 4.56667C5.5 4.05903 5.64662 3.56279 5.92133 3.1407C6.19603 2.71862 6.58648 2.38964 7.04329 2.19538C7.50011 2.00111 8.00277 1.95028 8.48773 2.04932C8.97268 2.14835 9.41814 2.39281 9.76777 2.75176C10.1174 3.11072 10.3555 3.56805 10.452 4.06594C10.5484 4.56382 10.4989 5.07989 10.3097 5.54889C10.1205 6.01789 9.80005 6.41874 9.38893 6.70077C8.9778 6.9828 8.49445 7.13333 8 7.13333C7.33696 7.13333 6.70107 6.86292 6.23223 6.38157C5.76339 5.90023 5.5 5.24739 5.5 4.56667ZM13 11.5333V13H3V11.5333C3 11.5333 3 8.6 8 8.6C13 8.6 13 11.5333 13 11.5333Z",
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M17.2859 12.0086L13.9999 8.74377L15.2437 7.5L17.2859 9.52102L20.2964 6.51053L20.7436 6L21.9874 7.24377L17.2859 12.0086Z",
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "svg-fill",
    x: 3,
    y: 15,
    width: 18,
    height: 2,
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "svg-fill",
    x: 3,
    y: 19,
    width: 13,
    height: 2,
    fill: "#605E5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1779_3381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequiredActions);
export default __webpack_public_path__ + "static/media/required_actions.f61f7a4f3e8b1fd712c2637e43fd7ee7.svg";
export { ForwardRef as ReactComponent };